import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  RankListItemMessage,
  RankListResponseWrapper,
} from 'src/app/api/models';

export const ranklistEntityKey = 'ranklist';

export interface RanklistEntity
  extends RankListItemMessage,
    RankListResponseWrapper {}

export interface RanklistState extends EntityState<RanklistEntity> {}

export const adapter: EntityAdapter<RanklistEntity> =
  createEntityAdapter<RanklistEntity>();

const initialRanklistState: RanklistState = adapter.getInitialState(
  {} as RanklistState,
);

export function getInitialRanklistState(): RanklistState {
  return initialRanklistState;
}
